<template>
  <md-dialog
    :md-active.sync="show"
    :md-close-on-esc="false"
    class="warning-dialog"
    @md-clicked-outside="closeDialog"
    @keyup.esc="closeDialog"
  >
    <md-dialog-title>
      Delete User
    </md-dialog-title>
    <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <div class="md-subheading warning-text">
        This action deletes this user permanently, Are you sure?
      </div>
      <div dir="rtl">
        <md-button class="md-primary" @click="deleteUser">Next</md-button>
        <md-button @click="closeDialog">close</md-button>
      </div>
    </div>
  </md-dialog>
</template>

<script>
export default {
  name: "DeleteUser",
  props: ["show", "application_user_pk"],
  methods: {
    closeDialog: function() {
      this.$emit("close");
    },
    deleteUser: async function() {
      const response = await this.$api.deleteUser({
        params: {
          application_user_pk: this.application_user_pk
        }
      });
      if (response.status === 200) this.$emit("deleted", response.parsedData.message);
      else this.$emit("failed", response.parsedError);
    }
  }
};
</script>

<style scoped></style>
